export default __webpack_public_path__ + "static/media/hero-landing.c4ade4fb.png";